import React from 'react';
import Section from './layouts/Section';
import AboutArea from './layouts/AboutArea';
import PageLayout from './layouts/PageLayout';

const AboutUs = () => {
  return (
    <PageLayout
      title="About Cell Station | Trusted Phone Repair Since 2006 in Willow Grove, PA"
      description="Cell Station has served Willow Grove, PA for 19+ years with 10,000+ repairs completed. Learn about our story, team, and commitment to quality."
      url="https://www.icellstation.com/about-us"
    >
      <Section title="About Us">
        <AboutArea background={false} />
      
       <iframe
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1112.526522562257!2d-75.12602792321633!3d40.13197566201095!2m3!1f0!2f39.121133786135466!3f0!3m2!1i1024!2i768!4f35!3m3!1m2!1s0x89c6b1fc42ab6fef%3A0x7c78b804e3a9c5ec!2sCell%20Station!5e1!3m2!1sen!2sus!4v1730661192650!5m2!1sen!2sus"
  width="100%"
  height="500"
  title="Cell Station Location"
  style={{ border: 0 }}
  allowFullScreen
/>
      </Section>
    </PageLayout>
  );
};

export default AboutUs;
